const login = "/login";
const forgotPassword = "/forgot-password";
const home = "/";
const authenticationToken = "/v1/tokens/authentication";
const passwordReset = "/v1/tokens/password-reset";
const getBoards = "/v1/boards";
const getSubjects = "/v1/subjects";
const getClasses = "/v1/classes";
const getSubjectMapping = "/v1/subjectsmap";
const getChapters = "/v1/chapters";
const getTopics = "/v1/topics";
const localHost = "http://localhost:3000";
const alloweMail = ["@schooglink.com", "@schooglink.in"];

export {
  login,
  forgotPassword,
  home,
  authenticationToken,
  passwordReset,
  getBoards,
  getSubjects,
  getClasses,
  getSubjectMapping,
  getChapters,
  getTopics,
  localHost,
  alloweMail,
};
